{
  "schemaVersion": 1,
  "id": "pdf-toolkit",
  "version": "1.0.0",
  "name": "PDF Toolkit",
  "description": "Combine images and PDFs, reorder, rotate, split, and shrink pages without uploading them.",
  "categories": ["PDF", "Documents"],
  "icon": "file-text",
  "script": "run.mjs",
  "interface": {
    "type": "html",
    "entry": "ui.html"
  },
  "requiredExecutables": [],
  "configuration": []
}
